// account-ui catalog — locale pl (register: Pan/Pani, formal).
import en from './en';

const pl: typeof en = {
  common: {
    loading: 'Ładowanie…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'Pana/Pani konto lumi HR',
      intro:
        'Ta strona należy do Pana/Pani, a nie do przestrzeni roboczej. Pozostaje dostępna także wtedy, gdy przestrzeń robocza, do której Pan/Pani należy, jest zablokowana lub zamknięta.',
      rightsTitle: 'Co można tutaj zrobić',
      rights: {
        takeout: 'Pobrać kopię swoich danych, gdy tylko zostanie przygotowana.',
        erasure:
          'Złożyć wniosek o usunięcie przestrzeni roboczej i jej danych albo wycofać własny wniosek.',
        invoices: 'Przeglądać i pobierać faktury przestrzeni roboczej, którą Pan/Pani zarządza.',
        export:
          'Wyeksportować przestrzeń roboczą, której Pan/Pani jest właścicielem — wszystkie dane w jednym zaszyfrowanym archiwum.',
      },
      signInHint:
        'Każda z tych czynności wymaga wcześniejszego zalogowania. Link, który wysyłamy e-mailem, prowadzi wyłącznie na tę stronę — nigdy nie loguje.',
      workspaceHint:
        'Wszystko inne – codzienna praca i ustawienia – pozostaje w przestrzeni roboczej.',
    },
    signIn: {
      title: 'Logowanie',
      intro:
        'Prosimy podać swój adres e-mail w lumi HR i hasło. Nie trzeba wskazywać przestrzeni roboczej — pokażemy te, do których Pan/Pani należy.',
      email: 'Adres e-mail',
      password: 'Hasło',
      submit: 'Zaloguj',
      failed: 'Nie udało się zalogować przy użyciu tego adresu e-mail i hasła.',
      passkey: 'Zaloguj kluczem dostępu',
      passkeyHint:
        'Brak adresu e-mail? Konto założone z numerem telefonu komórkowego loguje się swoim kluczem dostępu.',
      passkeyFailed: 'Nie udało się zalogować przy użyciu tego klucza dostępu.',
      operatorSecondFactor: 'To jest konto administratora systemu, które wymaga drugiego składnika. Tutaj zaloguj się kluczem dostępu; hasłem i kodem uwierzytelniającym zaloguj się w konsoli lumi.',
    },
    session: {
      signedInAs: 'Zalogowano jako {email}.',
      signOut: 'Wyloguj',
    },
    workspaces: {
      title: 'Przestrzenie robocze',
      intro:
        'Przestrzenie robocze, do których Pan/Pani należy. Zablokowana przestrzeń pozostaje na tej liście — właśnie po to jest ta strona.',
      emptyTitle: 'Brak przestrzeni roboczych',
      emptyBody:
        'To konto nie należy do żadnej przestrzeni roboczej. Jeśli miała się tu pojawić, prosimy zwrócić się do osoby, która wysłała zaproszenie.',
      loadFailed: 'Nie udało się wczytać przestrzeni roboczych.',
      ssoRequired:
        'Ta przestrzeń robocza wymaga firmowego logowania SSO. Aby skorzystać z tych funkcji, prosimy zalogować się przez samą przestrzeń roboczą — hasło nie otwiera jej w tym miejscu.',
      state: {
        active: 'Aktywna',
        suspended: 'Zablokowana',
        provisioning: 'W przygotowaniu',
        erased: 'Usunięta',
        unavailable: 'Niedostępna',
      },
      hint: {
        active: 'Ta przestrzeń robocza działa normalnie.',
        suspended:
          'Ta przestrzeń robocza jest zablokowana. Mimo to może tu Pan/Pani skorzystać ze swoich praw.',
        provisioning: 'Ta przestrzeń robocza jest jeszcze przygotowywana.',
        erased:
          'Ta przestrzeń robocza i jej dane zostały usunięte. Pozostają wyłącznie faktury, ponieważ mamy obowiązek je przechowywać.',
        unavailable: 'Ta przestrzeń robocza jest obecnie niedostępna.',
      },
    },
    invoices: {
      open: 'Pokaż faktury',
      hide: 'Ukryj faktury',
      empty: 'Dla tej przestrzeni roboczej nie ma faktur.',
      loadFailed: 'Nie udało się wczytać faktur tej przestrzeni roboczej.',
      download: 'Pobierz PDF',
      documentMissing: 'Do tej faktury nie ma dokumentu do pobrania.',
      documentUnavailable:
        'Dokumentu faktury nie można teraz pobrać. Nadal istnieje — prosimy spróbować ponownie za chwilę.',
      downloadFailed: 'Nie udało się pobrać tej faktury.',
    },
    takeout: {
      title: 'Kopia Pana/Pani danych',
      what:
        'To kopia danych osobowych, które ta przestrzeń robocza przechowuje na temat Pana/Pani, wraz z wyjaśnieniem, do czego są wykorzystywane.',
      availableUntil:
        'Można ją pobrać do {date}. Potem zostanie automatycznie usunięta – proszę zapisać ją wcześniej, jeśli ma zostać zachowana.',
      download: 'Pobierz moje dane',
      none: 'Nie czeka tu teraz żadna kopia Pana/Pani danych.',
      expired:
        'Przygotowaną kopię można było pobrać do {date}. Została już usunięta, zgodnie z zapowiedzią.',
      howToAsk:
        'O kopię można poprosić w każdej chwili: proszę zwrócić się do przestrzeni roboczej, która przechowuje Pana/Pani dane. Gdy kopia będzie gotowa, wyślemy wiadomość e-mail, a pobrać ją można na tej stronie.',
      loadFailed: 'Nie udało się sprawdzić, czy czeka tu kopia Pana/Pani danych.',
      downloadUnavailable:
        'Kopii nie można teraz pobrać. Nadal istnieje – proszę spróbować ponownie za chwilę.',
      downloadFailed: 'Nie udało się pobrać kopii Pana/Pani danych.',
    },
    export: {
      title: 'Eksport tej przestrzeni roboczej',
      intro:
        'Proszę pobrać całą zawartość tej przestrzeni roboczej w jednym zaszyfrowanym archiwum. Działa to również wtedy, gdy przestrzeń jest zablokowana — właśnie po to jest ta strona.',
      contents:
        'Archiwum zawiera dane każdej osoby, każdy plik przesłany do przestrzeni roboczej oraz jej połączenia z innymi usługami. Proszę traktować je jak samą przestrzeń roboczą: przechowywać w bezpiecznym miejscu i nie przekazywać nikomu, kto nie powinien widzieć całości. Archiwum zawiera też, dla modułów Kadry, Rekrutacja i Czas, dokument HR Open Standards (HR-JSON) — wspólny format na wypadek zmiany dostawcy.',
      passphraseWarning:
        'Hasło wybiera Pan/Pani samodzielnie, a my nigdy go nie przechowujemy. Bez niego archiwum nie da się już otworzyć — ani Panu/Pani, ani nam.',
      passphraseLabel: 'Hasło do archiwum',
      passphraseHint: 'Co najmniej {min} znaków.',
      confirmLabel: 'Proszę powtórzyć hasło',
      submit: 'Rozpocznij eksport',
      started:
        'Eksport został rozpoczęty. Przygotowanie chwilę potrwa — proszę wrócić na tę stronę i odświeżyć listę.',
      errorTooShort: 'Proszę wybrać hasło o długości co najmniej {min} znaków.',
      errorMismatch: 'Oba hasła nie są takie same. Proszę je sprawdzić i spróbować ponownie.',
      errorCannotStart:
        'Eksportu nie można teraz rozpocząć: być może inny eksport tej przestrzeni roboczej już trwa, albo przestrzeń robocza jest właśnie zamykana.',
      errorTooMany:
        'Ta przestrzeń robocza rozpoczęła dziś tyle eksportów, ile jej przysługuje. Proszę spróbować jutro.',
      errorGeneric:
        'Nie udało się rozpocząć eksportu. Nic nie zostało zmienione – proszę spróbować ponownie za chwilę.',
      listTitle: 'Eksporty tej przestrzeni roboczej',
      refresh: 'Odśwież',
      loadFailed: 'Nie udało się wczytać eksportów tej przestrzeni roboczej.',
      empty: 'Dla tej przestrzeni roboczej nie utworzono jeszcze żadnego eksportu.',
      startedAt: 'Rozpoczęto {date}',
      availableUntil: 'Można pobrać do {date}',
      download: 'Pobierz archiwum',
      downloadGone:
        'Tego archiwum już nie ma. Proszę rozpocząć nowy eksport, aby otrzymać kolejne.',
      downloadUnavailable:
        'Archiwum nie można teraz pobrać. Nadal istnieje – proszę spróbować ponownie za chwilę.',
      downloadFailed: 'Nie udało się pobrać archiwum.',
      status: {
        requested: 'W kolejce',
        exporting: 'W przygotowaniu',
        exported: 'Gotowe do pobrania',
        failed: 'Niepowodzenie',
        expired: 'Usunięte',
        unknown: 'Status nieznany',
      },
    },
    erasure: {
      file: 'Złóż wniosek o usunięcie tej przestrzeni roboczej',
      loadFailed:
        'Nie udało się sprawdzić, czy dla tej przestrzeni roboczej złożono wniosek o usunięcie.',
      confirmTitle: 'Złożyć wniosek o usunięcie tej przestrzeni roboczej?',
      confirmWhatGoes:
        'Wszystko w przestrzeni „{workspace}” zostanie trwale usunięte: każda teczka pracownika, każda aplikacja o pracę, każdy dokument, każdy wpis czasu pracy i każde ustawienie — dla wszystkich osób, które w niej pracują. Później nie da się tego odzyskać.',
      confirmProcess:
        'Składa Pan/Pani wniosek, nic jeszcze nie zostaje usunięte. Rozpatrujemy go, a po zatwierdzeniu rozpoczyna się okres oczekiwania. Do chwili faktycznego rozpoczęcia usuwania wniosek można w każdej chwili wycofać.',
      invoicesKept: 'Faktury pozostają, ponieważ prawo nakazuje nam ich przechowywanie.',
      reason: 'Powód (opcjonalnie)',
      keep: 'Nie, zachowaj tę przestrzeń roboczą',
      confirmSubmit: 'Tak, złóż wniosek o usunięcie',
      pendingReview:
        'Dla tej przestrzeni roboczej złożono wniosek o usunięcie. Rozpatrujemy go.',
      pendingUntil:
        'Dla tej przestrzeni roboczej złożono wniosek o usunięcie. Zostanie usunięta po {date}.',
      paymentsPending:
        'Ta przestrzeń robocza jest przeznaczona do usunięcia, ponieważ konto nie zostało opłacone.',
      paymentsPendingUntil:
        'Ta przestrzeń robocza jest przeznaczona do usunięcia, ponieważ konto nie zostało opłacone. Zostanie usunięta po {date}.',
      paymentsSettle:
        'Opłacenie zaległej faktury zatrzymuje to usunięcie. Może Pan/Pani również samodzielnie złożyć wniosek o usunięcie — wtedy nastąpi ono niezależnie od płatności.',
      paymentsCannotWithdraw:
        'To usunięcie zaplanowano, ponieważ konto nie zostało opłacone, dlatego nie można go tutaj wycofać. Prosimy opłacić zaległą fakturę, aby je zatrzymać.',
      confirmTakeover:
        'Ta przestrzeń robocza jest już przeznaczona do usunięcia, ponieważ konto nie zostało opłacone. Pana/Pani wniosek przejmuje to usunięcie: opłacenie faktury już go nie zatrzyma.',
      withdraw: 'Wycofaj wniosek o usunięcie',
      withdrawTitle: 'Wycofać wniosek o usunięcie?',
      withdrawBody:
        'Ta przestrzeń robocza i wszystkie dane zostają zachowane. Może Pan/Pani ponownie złożyć wniosek o usunięcie w dowolnym momencie.',
      confirmType: 'Aby potwierdzić, prosimy wpisać nazwę przestrzeni roboczej ({name})',
      confirmMismatch:
        'Wpisana nazwa nie pasuje do tej przestrzeni roboczej. Prosimy ją sprawdzić i spróbować ponownie.',
      tooLate: 'Usuwanie już się rozpoczęło i nie można go wycofać.',
      conflict: 'Ta przestrzeń robocza jest już usuwana, więc nic się nie zmieniło.',
      nothingOpen: 'Dla tej przestrzeni roboczej nie ma wniosku o usunięcie do wycofania.',
      filed: 'Wniosek o usunięcie został złożony. Sprawdzimy go.',
      withdrawn: 'Wniosek o usunięcie został wycofany. Ta przestrzeń robocza zostaje zachowana.',
    },
    closure: {
      title: 'Zamknięcie konta lumi',
      intro:
        'Chodzi tu o samo konto lumi — o logowanie — a nie o jedną z przestrzeni roboczych powyżej.',
      open: 'Zamknij moje konto',
      confirmTitle: 'Zamknąć konto lumi?',
      whatGoes:
        'Logowanie przestaje istnieć: ten adres e-mail i to hasło przestają działać, powiązane firmowe logowanie jednokrotne zostaje odłączone, a Pan/Pani opuszcza każdą przestrzeń roboczą, do której należy. Znika też to, co pozostało po korzystaniu z lumi: usuwamy rozmowy z asystentem, powiadomienia, które wysyłaliśmy, oraz ustawienia powiadomień, a ze zgłoszeń do pomocy technicznej i wiadomości skierowanych do nas usuwamy dane Pana/Pani oraz treść.',
      whatStays:
        'Dane u poszczególnych pracodawców pozostają u tych pracodawców. lumi udostępnia systemy, ale za swoje dane kadrowe i rekrutacyjne odpowiada każda firma sama, a zamknięcie konta w tym miejscu ich nie usuwa. Jeśli dana przestrzeń robocza jest objęta postępowaniem sądowym lub urzędowym, musimy zachować to, co jest z nią związane: zgłoszenia, wiadomości i rozmowy z tej przestrzeni pozostają do czasu jego zakończenia.',
      howToErase:
        'Jeśli chcą Państwo usunięcia danych, które posiada pracodawca, prosimy zwrócić się bezpośrednio do danej firmy. To ona rozpatruje taki wniosek, a część danych musi jeszcze przez pewien czas przechowywać zgodnie z prawem.',
      noUndo:
        'Zamknięcia nie da się cofnąć i nic nie zostaje dla Pana/Pani zachowane. W dowolnym momencie można zarejestrować się ponownie na ten sam adres e-mail — powstanie wtedy nowe, puste konto.',
      confirmType: 'Aby potwierdzić, prosimy wpisać swój adres e-mail ({email})',
      confirmMismatch:
        'To nie jest adres e-mail tego konta. Prosimy go sprawdzić i spróbować ponownie.',
      keep: 'Nie, zachowaj konto',
      confirmSubmit: 'Tak, zamknij konto',
      doneTitle: 'Konto zostało zamknięte',
      doneBody:
        'Sesja została zakończona, a tym adresem e-mail i tym hasłem nie można już zalogować się nigdzie w lumi. Rozmowy z asystentem i powiadomienia, które wysyłaliśmy, zostały usunięte, a zgłoszenia do pomocy technicznej i wiadomości skierowane do nas nie zawierają już danych Pana/Pani ani treści.',
      doneStays:
        'Dane u poszczególnych pracodawców pozostają u tych pracodawców i nadal są przez nich zarządzane. W sprawie ich usunięcia prosimy zwrócić się bezpośrednio do danej firmy. Jeśli natomiast dana przestrzeń robocza jest objęta postępowaniem sądowym lub urzędowym, to, co jest z nią związane, pozostaje u nas do czasu jego zakończenia.',
      doneMailed: 'Wysłaliśmy potwierdzenie na adres e-mail.',
      doneNotMailed:
        'Nie udało się wysłać wiadomości z potwierdzeniem. Konto i tak zostało zamknięte.',
      blockedTitle: 'Te przestrzenie robocze nadal potrzebują właściciela',
      blockedBody:
        'Jest Pan/Pani jedynym właścicielem poniższych przestrzeni roboczych, dlatego nie możemy jeszcze zamknąć konta. Przestrzeń bez właściciela możemy otworzyć ponownie tylko my, a wszystkie pracujące w niej osoby straciłyby dostęp do własnych danych.',
      blockedTransfer:
        'Prosimy przekazać „{name}”: wystarczy otworzyć tę przestrzeń roboczą i przenieść tam własność na innego członka.',
      blockedErasure:
        'Albo złożyć wniosek o usunięcie „{name}” na liście przestrzeni roboczych powyżej.',
      blockedReturn:
        'Ta próba nie zostaje zapamiętana. Gdy żadna przestrzeń robocza nie będzie już potrzebowała Pana/Pani jako właściciela, prosimy wrócić na tę stronę i wtedy zamknąć konto.',
      unavailable:
        'Zamykanie kont chwilowo nie działa. Nic nie zostało zmienione — prosimy spróbować za chwilę.',
      alreadyClosed: 'To konto jest już zamknięte.',
      failed: 'Nie udało się. Konto nie zostało zamknięte — prosimy spróbować za chwilę.',
      confirmTypePhone:
        'Aby potwierdzić, prosimy wpisać pełny numer telefonu komórkowego ({phone})',
      confirmMismatchPhone:
        'To nie jest numer telefonu komórkowego tego konta. Prosimy go sprawdzić i spróbować ponownie.',
      whatGoesPhone:
        'Logowanie przestaje istnieć: klucze dostępu i ten numer telefonu komórkowego przestają działać, powiązane firmowe logowanie jednokrotne zostaje odłączone, a Pan/Pani opuszcza każdą przestrzeń roboczą, do której należy. Znika też to, co pozostało po korzystaniu z lumi: usuwamy rozmowy z asystentem, powiadomienia, które wysyłaliśmy, oraz ustawienia powiadomień, a ze zgłoszeń do pomocy technicznej i wiadomości skierowanych do nas usuwamy dane Pana/Pani oraz treść.',
      noUndoPhone:
        'Zamknięcia nie da się cofnąć i nic nie zostaje dla Pana/Pani zachowane. Przestrzeń robocza może ponownie zaprosić Pana/Panią na ten sam numer — powstanie wtedy nowe, puste konto.',
      doneBodyPhone:
        'Sesja została zakończona, a kluczami dostępu i tym numerem telefonu komórkowego nie można już zalogować się nigdzie w lumi. Rozmowy z asystentem i powiadomienia, które wysyłaliśmy, zostały usunięte, a zgłoszenia do pomocy technicznej i wiadomości skierowane do nas nie zawierają już danych Pana/Pani ani treści.',
      doneScreenOnly: 'Ten ekran jest potwierdzeniem — nie wysyłamy go SMS-em.',
    },
  },
};

export default pl;
